import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventSourceService {

  url: string = '';

  setUrl(url: string): void {
    this.url = url;
  }

  reset(): void {
    this.url = '';
  }

  getInstance(): EventSource {
    const result = new EventSource(this.url, {withCredentials: false});
    this.reset();
    return result;
  }
}
